var React = require('react');

function Github (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1731.023,5158.19a12.373,12.373,0,0,0-3.91,24.112c.619.113.845-.268.845-.6,0-.294-.011-1.071-.017-2.1-3.441.748-4.167-1.658-4.167-1.658a3.274,3.274,0,0,0-1.374-1.81c-1.123-.768.085-.751.085-.751a2.6,2.6,0,0,1,1.9,1.274,2.633,2.633,0,0,0,3.6,1.028,2.645,2.645,0,0,1,.786-1.654c-2.747-.312-5.636-1.373-5.636-6.115a4.783,4.783,0,0,1,1.274-3.32,4.449,4.449,0,0,1,.121-3.275s1.039-.333,3.4,1.269a11.725,11.725,0,0,1,6.195,0c2.362-1.6,3.4-1.269,3.4-1.269a4.442,4.442,0,0,1,.123,3.275,4.775,4.775,0,0,1,1.272,3.32c0,4.753-2.893,5.8-5.649,6.105a2.953,2.953,0,0,1,.84,2.291c0,1.655-.015,2.99-.015,3.4,0,.33.223.715.851.594a12.374,12.374,0,0,0-3.919-24.111Z","transform":"translate(-1718.651 -5158.19)","fillRule":"evenodd"}));
}

Github.defaultProps = {"width":"24.745","height":"24.134","viewBox":"0 0 24.745 24.134"};

module.exports = Github;

Github.default = Github;
